<!--
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2022-06-10 11:07:29
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-06-15 17:40:47
 * @FilePath: /jy-dashboard-web/src/components/companyProfile/map-dttl.vue
 * @Description: 地图图例
-->
<template>
  <div class="dttl">
    <section class="legend" v-for="(item, index) in data" :key="index">
      <i class="icon" :style="{ 'background-image': `url(${item.icon})` }" />
      <span class="name">{{ item.name }}</span>
    </section>
  </div>
</template>

<script>
export default {
  data () {
    return {
      data: [
        { name: '抹茶产业基地', icon: '/image/company-profile/map/抹茶产业基地@2x.png' },
        { name: '绿茶产业基地', icon: '/image/company-profile/map/绿茶产业基地@2x.png' },
        { name: '红茶产业基地', icon: '/image/company-profile/map/红茶产业基地@2x.png' },
        { name: '乌龙茶产业基地', icon: '/image/company-profile/map/乌龙茶产业基地@2x.png' },
        { name: '白茶产业基地', icon: '/image/company-profile/map/白茶产业基地@2x.png' },
        { name: '茉莉花茶产业基地', icon: '/image/company-profile/map/茉莉花茶产业基地@2x.png' },
        { name: '有机茶产业基地', icon: '/image/company-profile/map/有机茶产业基地@2x.png' },
        { name: '脱咖茶产业基地', icon: '/image/company-profile/map/脱咖茶产业基地@2x.png' }
      ]
    }
  }
}
</script>

<style lang='scss'>
.dttl {
  .legend {
    margin-bottom: 24px;
    &:last-of-type {
      margin-bottom: 0;
    }
    .icon {
      display: block;
      width: 30.2px;
      height: 31px;
      margin: 0 auto;
    }
    .name {
      display: block;
      text-align: center;
      font-size: 10px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      margin-top: 3px;
    }
  }
}
</style>
